import { STATSIG_EXPERIMENTS, statsigExperimentManager } from '@src/experiments/statsig-integration'
import Product from '@src/quince-site-common/src/domains/Product'
import { ProductOptionName } from '@src/quince-site-common/src/domains/ProductOption'
import { ProductVariantOption } from '@src/quince-site-common/src/domains/ProductVariant'
import productHelper from '@src/quince-site-common/src/helpers/productHelper'
import { VIDEO_FORCE_POSITION } from '@src/quince-site-common/src/utils/constants'

export const getIsCurrentProductOptionLeavingSoon = (
  product: Product,
  updatedSelectedOptions?: ProductVariantOption[],
) => {
  if (!product.variants) return false

  const variants = productHelper.getVariantsForOptions(product, updatedSelectedOptions)
  if (variants.length === 1) {
    return variants[0]?.lastChance === 'true'
  }
  return false
}

export const getVideoInfoForColor = ({ product, currentColor }: { product?: Product; currentColor: string | null }) => {
  if (!currentColor || !product) return null

  const colorOptions: ProductVariantOption[] = [
    new ProductVariantOption({
      name: ProductOptionName.Color,
      value: currentColor,
    }),
  ]

  const exposedExperiments = statsigExperimentManager.getExposedBuckets()
  const videoExperimentBucket =
    exposedExperiments.find(experiment => experiment.experimentName === STATSIG_EXPERIMENTS.PDP_VIDEO_FORMAT)
      ?.bucketName ?? ''

  const productMedia = productHelper.getProductMedia(product, colorOptions, {
    forcedVideoPosition: VIDEO_FORCE_POSITION,
    experimentBucket: videoExperimentBucket,
  })

  const video = productMedia.find(media => 'video' in media)
  const videoIndex = productMedia.findIndex(media => 'video' in media)
  const experimentVideo = productHelper.getVideoExperimentForOptions(product, colorOptions, videoExperimentBucket)

  if (video) {
    return {
      videoId: video?.video?.id,
      videoFormat: experimentVideo && videoExperimentBucket ? videoExperimentBucket : undefined,
      videoPosition: videoIndex,
    }
  }

  return null
}
